import { useEffect } from "react";

function useOnLeavePage(onNavigateAway: () => void) {
	useEffect(() => {
		const handleBeforeUnload = () => {
			const navEntries = performance.getEntriesByType("navigation");
			const isReload =
				navEntries.length > 0 &&
				(navEntries[0] as PerformanceNavigationTiming).type === "reload";

			if (isReload) {
				// Ignore refresh
				return;
			}

			// Call your custom logic
			onNavigateAway();

			// Trigger browser's unload confirmation
			// event.preventDefault();
			// event.returnValue = "";
		};

		window.addEventListener("beforeunload", handleBeforeUnload);

		return () => {
			window.removeEventListener("beforeunload", handleBeforeUnload);
		};
	}, [onNavigateAway]);
}

export default useOnLeavePage;
